import { customStyle, pxToRem, mediaQueries } from 'styles/functions'

const Theme = {
  alatable: true,
  body_background_color: 'black',

  card_background_color: 'black',
  card_text_centered: true,

  header_border_color: '#959595',
  header_height: 70,

  card_header_title_centered: true,
  card_header_b_color: '#f00000',
  card_header_margin_top: 35,

  logo_image_url: 'alatable.png',
  logo_height: 36,

  token_hidden: true,

  image_icon_hidden: true,

  button_color: '#f00000',
  button_width: 230,
  button_centered: true,
  button_text_weight: 800,
  button_half_border_color: '#f00000',
  button_half_max_width: 160,

  text_font: `'Open Sans', sans-serif`,
  text_color: 'white',

  popup_text_color: 'black',

  title_font: `'Open Sans', sans-serif`,
  title_color: 'white',
  title_weight: 600,
  title_size: 24,

  subtitle_weight: 800,
  subtitle_margin: 28,
  subtitle_text_transform: 'uppercase',

  input_margins: 10,
  input_error_color: '#bba98c',
  input_error_size: 18,
  input_error_margin: 5,
  input_text_color: 'black',
  input_label_color: '#bba98c',
  input_label_margin: 10,
  input_max_width: 120,
  input_centered: true,

  trigger_hide_loader: true,
  trigger_hide_toast: true,

  modal_padding: 40,
  modal_img_margin: 5,
  modal_input_text_center: true,

  list_item_title_weight: 800,
  list_item_title_remove_margin_bottom: true,
  list_item_subtitle_weight: 400,
  list_border_bottom_color: '#bba88d',
  list_border_bottom_height: 2,

  separator_color: '#bba98c',
  separator_height: 2,

  footer_border_color: '#f00000',
  footer_border_height: 15,
  footer_text_color: 'white',

  custom_listitem_title_alatable: customStyle(`
    font-weight: 900;
    text-transform: uppercase;
    margin-bottom: -${pxToRem(18)}
  `),

  custom_listitem_subtitle_alatable: customStyle(`
    font-weight: 500;
    text-transform: none;
    margin-bottom: -${pxToRem(10)}
  `),
}

export default Theme
